import { useLastLocation } from '#app/hooks/useLastLocation.js';
import { useReferrerUrl } from '#app/hooks/useReferrerUrl.js';

// Returns true when previous location exists
// or referrer is CWA or CLP
export const useIsInternalTraffic = () => {
  const referrerUrl = useReferrerUrl();
  const lastLocation = useLastLocation();

  return lastLocation !== null || referrerUrl?.includes('contra.com');
};
